<div class="p-fluid p-formgrid p-grid">
  <div class="p-field p-col-12 p-md-3">
    <p-card (keyup)="onEnterPesquisar($event)">
      <div class="p-card-title">
        Filtros
      </div>
      <div class="p-grid">
        <m-restricao-number label="Id" [restricao]="restricoes.atributo('id')"></m-restricao-number>
        <m-restricao-string label="Fonte de Dados" [restricao]="restricoes.atributo('fonteDados.nome')"></m-restricao-string>
        <m-restricao-string label="Origem Id" [restricao]="restricoes.atributo('origemId')"></m-restricao-string>
      </div>
      <div class="p-fluid">

        <div class="p-field">
          <label for="firstname1">Petição  Inicial?</label>
          <div *ngFor="let petInicialItem of peticaoInicialFiltroItens" style="padding: 2px 0">
            <p-radioButton name="mlr_{{petInicialItem.id}}_operador" [(ngModel)]="peticaoInicialFiltro"
                           [value]="petInicialItem.value" [label]="petInicialItem.label"></p-radioButton>
          </div>
        </div>

        <div class="p-field">
          <label>Número de processo</label>
          <p-inputMask [(ngModel)]="restricoes.atributo('numeroProcesso').valor" mask="9999999-99.9999.9.99.9999"
                       [autoClear]="false"></p-inputMask>
        </div>
      </div>
      <p-footer>
        <div class="p-grid p-fluid">
          <div class="p-field p-col">
            <button pButton label="Pesquisar" (click)="pesquisar()"></button>
          </div>
          <div class="p-field p-col">
            <button pButton class="p-button-secondary" label="Limpar" (click)="limpar()"></button>
          </div>
        </div>
      </p-footer>
    </p-card>
  </div>

  <div class="p-col-12 p-md-9">
    <p-card>
      <div class="p-card-title">
        Processos
        <span *ngIf="carregandoProcessos">
          <em class="pi-fw pi pi-spin pi-spinner"></em>
        </span>
        <span *ngIf="error" style="color: red">
          <em class="pi pi-times" pTooltip="Erro ao carregar os dados da pesquisa!"></em>
        </span>
      </div>

      <div *ngIf="processos === undefined" style="text-align: center; height: 700px; line-height: 700px;">
        Por favor realize uma pesquisa
      </div>

      <div *ngIf="processos?.length === 0" style="text-align: center; height: 700px; line-height: 700px;">
        Nenhum resultado foi encontrado
      </div>
      <div *ngIf="processos !== undefined" [hidden]="processos?.length === 0">
        <p-virtualScroller
          #vsProcessos class="processos"
          [value]="processos"
          scrollHeight="700px"
          [itemSize]="150"
          [rows]="quantidadeRegistros"
          [lazy]="true" (onLazyLoad)="onLazyLoad($event.first)">
          <ng-template let-processo pTemplate="item">
            <a class="processo border p-border-top" [routerLink]="['/processo/historico/', processo.id]">
              <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-6">
                  <ul class="list-group">
                    <li class="list-title-color"> <span class="numero-processo highlight">{{processo.id}} - {{processo.numero}}</span></li>
                    <li><span>{{processo.fonteDados.nome}} - {{processo.origemId}}</span></li>
                    <li>
                      <span *ngIf="processo.instancia == 'SEGUNDO_GRAU'">{{processo.distribuicaoAtual?.orgaoJulgadorColegiadoLocal?.nome}} - </span>
                      <span>{{processo.distribuicaoAtual?.orgaoJulgador.nome}}</span>
                    </li>
                    <li><span>{{processo.classeAtual?.classe?.id}} - {{processo.classeAtual?.classe?.descricao}}</span></li>
                  </ul>
                </div>
                <div class="p-field p-col-6">
                  <ul class="list-group">
                    <li class="list-group-item disabled onbadge" style="margin-left: -6px;">
                      <p class="label label-warning margem">{{processo.instancia}}</p>
                      <p *ngIf="processo.dataExclusao" class="label label-danger" [pTooltip]="processo.dataExclusao | date: 'dd/MM/yyyy HH:mm:ss'" style="text-transform: uppercase; margin-left: 4px;">
                        Excluído
                      </p>
                    </li>
                    <li class="list-group-item onbadge m-t-5 p-text-break">
                        <span *ngFor="let assunto of processo.assuntos">
                          <p class="label label-info">
                            <span>{{assunto.assunto.id}}</span> - <span> {{assunto.assunto.descricao}}</span>
                            </p>
                        </span>
                    </li>
                  </ul>
                </div>
              </div>
            </a>
          </ng-template>
          <ng-template let-car pTemplate="loadingItem">
            <div class="processo-carregando">
              <em class="pi-fw pi pi-spin pi-spinner"></em>
            </div>
          </ng-template>
        </p-virtualScroller>
      </div>
    </p-card>
  </div>
</div>
